module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-300.5e86df2c.woff";